import React from "react";
import { Slider, InputNumber } from "antd";
import {
  getHours,
  getMinutes,
  getSeconds,
  startOfDay,
  differenceInMilliseconds,
} from "date-fns";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import "../styles/components/time-slider.css";

const marks = {
  0: "0 AM",
  12.5: "3 AM",
  25: "6 AM",
  37.5: "9 AM",
  50: "12 PM",
  62.5: "3 PM",
  75: "6 PM",
  87.5: "9 PM",
  100: "0 AM",
};

class TimeSlider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      interval: props.interval,
    };
  }

  onAfterChange = (value) => {
    this.props.onChange(value);
  };

  onChangeInput = (value) => {
    this.props.onChangeInterval(value);
    this.setState(() => ({
      interval: value,
    }));
  };

  render() {
    // first time of range
    const fORHours = getHours(this.props.firstOfRange);
    const fORMinutes = getMinutes(this.props.firstOfRange);
    const fORSeconds = getSeconds(this.props.firstOfRange);
    const firstOfRange =
      ((fORHours * 60 * 60 + fORMinutes * 60 + fORSeconds) / (24 * 60 * 60)) *
      100;

    // last time of range
    const eORHours = getHours(this.props.endOfRange);
    const eORMinutes = getMinutes(this.props.endOfRange);
    const eORSeconds = getSeconds(this.props.endOfRange);
    const endOfRange =
      ((eORHours * 60 * 60 + eORMinutes * 60 + eORSeconds) / (24 * 60 * 60)) *
      100;

    // set max if it is today
    let max = 100;
    if (this.props.isToday) {
      const todayHours = getHours(new Date());
      const todayMinutes = getMinutes(new Date());
      const todaySeconds = getSeconds(new Date());

      max =
        ((todayHours * 60 * 60 + todayMinutes * 60 + todaySeconds) /
          (differenceInMilliseconds(new Date(), startOfDay(new Date())) /
            1000)) *
        100;
    }

    return (
      <div className="time-slider">
        <div className="time-slider__interval">
          <p>set interval: </p>
          <InputNumber
            min={10}
            max={600}
            defaultValue={this.state.interval}
            step={10}
            onChange={this.onChangeInput}
          />
        </div>
        <Slider
          range
          // disabled={this.props.hasHistory}
          marks={marks}
          max={max}
          tipFormatter={null}
          defaultValue={[firstOfRange, endOfRange]}
          step={100 / ((24 * 60 * 60) / this.state.interval)}
          onAfterChange={this.onAfterChange}
        />
      </div>
    );
  }
}

export default TimeSlider;
